export var isKey = function(event, key) {
    return event && key && event.key === key;
};
export var isWidthTruncated = function(event) {
    return event.target.offsetWidth && event.target.scrollWidth && event.target.offsetWidth < event.target.scrollWidth;
};
